import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@morpho-org/ui-v6/client';
import { Separator } from '@repo/ui';
import { memo } from 'react';
import { VaultList, type VaultListProps } from '@/components/common/VaultList';
export interface MarketCuratorHoverCardProps {
  curatorName: string;
  curatorLogoURI: string | null;
  vaults: VaultListProps['vaults'];
}
const MarketCuratorHoverCard = t0 => {
  const $ = _c(13);
  const {
    vaults,
    curatorName,
    curatorLogoURI
  } = t0;
  let t1;
  if ($[0] !== curatorLogoURI) {
    t1 = <Avatar src={curatorLogoURI} size="medium" />;
    $[0] = curatorLogoURI;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== curatorName) {
    t2 = <span className="text-foreground text-xs">{curatorName}</span>;
    $[2] = curatorName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="gap-2xs flex flex-row items-center p-[16px]">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== vaults) {
    t5 = <VaultList vaults={vaults} />;
    $[8] = vaults;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-col">{t3}{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default memo(MarketCuratorHoverCard);